<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">SelectDocument</v-card-title>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field class="widthsizesearch" v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mb-6">
          <v-btn class="mr-2" @click="showsearchmore">
            Filter
            <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="toggleEnable">
        <v-col cols="12" xl="2" lg="2" md="2" offset-md="8">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="datefrom" label="DateFrom" append-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  " @input="finddatafromdate"></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="2" lg="2" md="2">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateto" label="DateTo" append-icon="mdi-calendar" readonly outlined dense
                v-bind="attrs" v-on="on" clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  " @input="finddatafromdate"></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <v-data-table dense :search="search" :headers="headers" :items="mDataArray" class="elevation-1 tablecolorselect"
          show-select v-model="selected" item-key="id" @input="enterSelect($event)">
        </v-data-table>
      </v-card>
      <br />
      <v-card outlined tile>
        <v-row justify="center">
          <v-btn @click="opendialogConfirm()" :disabled="disableinstatus" color="#0A7EA5" rounded dark class="mb-2">
            Confirm
          </v-btn>
        </v-row>
      </v-card>
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogConfirm" fullscreen hide-overlay transition="dialog-bottom-transition"
            @keydown.esc="closedialogConfirm()">
            <v-card>
              <v-toolbar dark color="#4169e1">
                <v-toolbar-title>Receive Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="closedialogConfirm()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <BR />
              <BR />
              <v-list three-line subheader class="pa-16">
                <v-list-item>
                  <v-list-item-content>
                    <v-data-table :headers="headersRD" :items="mDataArrayRD" class="elevation-1 595959"></v-data-table>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-row class="mt-5">
                <v-col align="center" cols="12" md="12">
                  <v-btn depressed class="mr-5 buttonblue btn-width" width="130px" @click="SendDatatoAdd()">
                    Confirm List
                  </v-btn>
                  <v-btn depressed width="130px" class="buttonred btn-width" @click="closedialogConfirm()">
                    Cancel
                  </v-btn>
                  <!-- <v-btn depressed>
                                Cancel Request
                              </v-btn> -->
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-card>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Solist.js";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: 'SalesOrderForInvoice',
  data(vm) {
    return {
      customer_id: 0,
      dialogAdd: false,
      idInvCN: [],
      dialogConfirm: false,
      disableinstatus: true,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      dataAll: [],
      status: ["Draft", "Submit"],
      datefrom: null,
      dateto: null,
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      mDataArray: [],
      mDataArrayRD: [],
      authorize: [],
      selected: [],
      company_id: 0,
      headers: [
        {
          text: "Ivoice/CN",
          value: "receive_no",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Doc Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
          align: "start",
        },
        {
          text: "Client Name",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "sub_total",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
      ],
      headersRD: [
        {
          text: "Doc No.",
          value: "receive_no",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Doc Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Credit Term",
          value: "credit_term_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "sub_total",
          class: "bg-colorth tabletextwhite",
          align: "end"
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },
      ],
    };
  },
  components: {
    SuccessDialog,
  },
  async beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() { },
  beforeUpdate() { },
  computed: {
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    this.userId = localStorage.getItem(server.USER_ID);
    await this.loaddataInvCN();
  },
  methods: {
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    finddatafromdate() {
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.datefrom != null && this.dateto != null) {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        }
        if (this.datefrom == null && this.dateto == null) {
          return item;
        }
      });
    },
    async loaddataInvCN() {
      this.company_id = this.$route.params.company_inv;
      const result = await api.billing_expense_getReceiveSelect_ListBycompany({
        params: { company_id: this.company_id },
      });
      this.dataAll = result.data;
      this.dataAll.forEach((item) => {
        item.sub_total = tolocalestringnumber(Number(item.sub_total));
      });
      this.mDataArray = this.dataAll;
      // console.log(this.mDataArray);
      this.$hideLoader();
    },
    enterSelect(values) {
      // console.log(values);
      if (values.length > 0) {
        this.disableinstatus = false;
      } else {
        this.disableinstatus = true;
      }
      //senddata to create
      if (values.length == 1) {
        if (values[0].customer_id != null) {
          this.customer_id = values[0].customer_id;
          this.idInvCN[0] = values[0].id;
          // console.log(this.idInvCN);
        } else {
          this.customer_id = 0;
        }
      } else if (values.length > 1) {
        if (values[0].customer_id != null) {
          this.customer_id = values[0].customer_id;
        } else {
          this.customer_id = 0;
        }
        let customer_check = values[0].customer_name;
        for (let i = 0; i < values.length; i++) {
          this.idInvCN[i] = values[i].id;
          if (customer_check != values[i].customer_name) {
            values.splice(i, 1);
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "โปรดเลือกลูกค้าเดียวกัน",
              "text-h5 red--text text-center"
            );
          }
        }
      }
    },
    async closedialogConfirm() {
      this.dialogConfirm = false;
    },
    async opendialogConfirm() {
      this.mDataArrayRD = this.selected;
      this.dialogConfirm = true;
    },
    SendDatatoAdd() {
      this.idInvCN = [];
      this.selected.forEach((item, index) => {
        this.idInvCN[index] = item.id;
      });
      // console.log(this.idInvCN)
      this.$router.push(
        `/receive-confirm/${this.company_id}/${this.customer_id}/${this.idInvCN}`
      );
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}

.text-left {
  color: aliceblue;
}

.widthsizesearch {
  width: 70%;
}

.theme--light.v-card {
  border-color: white;
}
</style>
